import { render, staticRenderFns } from "./bills.vue?vue&type=template&id=2dc16107&scoped=true&"
import script from "./bills.vue?vue&type=script&lang=js&"
export * from "./bills.vue?vue&type=script&lang=js&"
import style0 from "./bills.vue?vue&type=style&index=0&id=2dc16107&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc16107",
  null
  
)

export default component.exports